<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container"> 
        <router-link to="/" class="navbar-brand navbar-brand-dynamic-color fade-page" tag="a"> 
          <img alt="Bukapo" src="../assets/bukapo.svg" height="55" width="150">
        </router-link>

        <div class="d-flex align-items-center order-lg-3">
          <router-link to="/masuk" class="btn btn-primary ml-lg-4 mr-3 mr-md-4 mr-lg-0 d-none d-sm-block order-lg-3" tag="a"> 
            Masuk 
          </router-link>
          <router-link to="/keranjang" class="btn btn-outline-primary ml-lg-4 mr-3 mr-md-4 mr-lg-0 d-none d-sm-block order-lg-3" tag="a"> 
            <i class="fas fa-shopping-cart"></i> Keranjang ({{ qty }}) 
          </router-link>

          <button aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
            data-target=".navbar-collapse" data-toggle="collapse" type="button">
            <img alt="Navbar Toggler Open Icon" class="navbar-toggler-open icon icon-sm" 
              src="assets/img/icons/interface/icon-menu.svg">
            <img alt="Navbar Toggler Close Icon" class="navbar-toggler-close icon icon-sm"
              src="assets/img/icons/interface/icon-x.svg">
          </button>
        </div>
        <div class="collapse navbar-collapse order-3 order-lg-2 justify-content-lg-end">
          <ul class="navbar-nav my-3 my-lg-0">
            <li class="nav-item"> 
                <router-link to="/carakerja" class="nav-link"> Cara Kerja </router-link>
            </li>
            <li class="nav-item"> 
                <router-link to="/daftar" class="nav-link"> Daftar </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>
export default {
  name: 'NavbarHeader'
}
</script>